import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable, map } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { MobileAuthService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class MobileAuthGuard implements CanActivate, CanActivateChild, CanMatch {
  constructor(
    protected authService: MobileAuthService,
    protected router: Router,
    @Inject(PLATFORM_ID) protected platformId: Object
  ) {}

  /**
   * Can activate route
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this.check(redirectUrl);
  }

  /**
   * Can activate child route
   */
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this.check(redirectUrl);
  }

  /**
   * Can match (replaces canLoad in Angular 15+)
   */
  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    const redirectUrl = '/' + segments.map((s) => s.path).join('/');
    return this.check(redirectUrl);
  }

  /**
   * Shared check method for all guards
   */
  private check(redirectURL: string): Observable<boolean | UrlTree> {
    return this.authService.check().pipe(
      map((authenticated) => {
        // Skip authentication check on server side
        if (!isPlatformBrowser(this.platformId)) {
          return true;
        }

        if (!authenticated) {
          // Return UrlTree to redirect before route activation
          return this.router.createUrlTree(['auth/login'], {
            queryParams: { redirectURL },
          });
        }
        return true;
      })
    );
  }
}